import { Link } from '@mui/material'
import { Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import ApplyLink from '../shared/ApplyLink'
import { application, instagramLink } from '../../data/info'
import applyImage from '../../resources/apply.png'

const Apply = () => {
  return (
    <Stack
      direction={{ md: 'row', xs: 'column' }}
      alignItems="center"
      sx={{
        height: { md: '440px', xs: 'inherit' },
        backgroundColor: '#F2F2F2',
        overflowY: 'visible',
      }}
      mt={{ md: 7, xs: 0 }}
      mb={{ md: 7, xs: 6 }}
    >
      <Stack
        alignItems={{ md: 'flex-start', xs: 'center' }}
        sx={{ width: { md: '48%', xs: '100%' } }}
        pl={{ md: '16.5%', xs: 3 }}
        pr={{ md: 0, xs: 3 }}
        pt={{ md: 0, xs: 5.5 }}
        mr={{ md: 4, xs: 0 }}
      >
        <Typography variant="sectionTitle2">Como participar?</Typography>
        <Typography variant="sectionText" pt={1.5}>
          As inscrições para o{' '}
          <Link color="interaction" variant="link" sx={{ display: 'inline' }} href={'./processo'}>
            processo seletivo da turma 2027/28
          </Link>{' '}
          foram encerradas em 13/09/2026. Nos acompanhe pelo{' '}
          <Link
            color="interaction"
            variant="link"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline' }}
            href={instagramLink}
          >
            Instagram
          </Link>{' '}
          para não perder nenhuma novidade!
        </Typography>
        <Typography variant="sectionText" pt={1} pb={{ xs: 2, md: 4 }}>
          {/* I didn't want to remake the spacing, so I'm leaving this purely to space out elements */}
        </Typography>
        <ApplyLink href={'./processo'}>Processo seletivo 2027-2028</ApplyLink>
      </Stack>
      <Box
        component="img"
        src={applyImage}
        alt="Estudantes colaborando na Academy"
        sx={{
          width: { md: '50%', xs: '108%' },
          height: { md: 'auto', xs: 'auto' },
          marginLeft: { md: 0, xs: '-8%' },
          marginBottom: { md: 4, xs: -6 },
        }}
      />
    </Stack>
  )
}

export default Apply
